import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Marathons/Prizes';

const { displayName } = config;

export default function MarathonPrizes(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать призы`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}
